import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//TODO peticion que trae toda las actas que tiene asignada el notificador
export const getActasNotificador = async () => {
  handlerLoading({ loading: true, loadName: "load_actas_notificador" });
  try {
    const response = await axios().get("/get_actas_notificador");
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_actas_notificador" });
  }
};

//TODO peticion que trae toda las actas que tiene asignada el notificador
export const actasNotificador = async (payload, params) => {
  const newParams = { page: params.page + 1, pageSize: params.pageSize };
  handlerLoading({ loading: true, loadName: "load_actas_notificador" });
  try {
    const response = await axios().post("/get_actas_notificador_pag", payload, {
      params: newParams,
    });
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_actas_notificador" });
  }
};

//TODO peticion reportar como NO NOTIFICADA al acta
export const reportarNoNotificada = async (dataSend, config) => {
  handlerLoading({ loading: true, loadName: "load_notificar" });
  try {
    // const response = await axios().post("/no_notificada", dataSend, config);
    const response = await axios().post("notificar_acta", dataSend, config);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    toast.success("Se reporto el acta exitosamente", toastOptions);
    handlerModal({ modal: false, modalName: "modal_motivo" });
    handlerModal({ modal: false, modalName: "modal_motivo_seleccionadas" });
    handlerModal({ modal: false, modalName: "modal_notificar" });
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_notificar" });
  }
};

//TODO peticion para notificar acta
export const notificar = async (dataSend) => {
  handlerLoading({ loading: true, loadName: "load_notificar" });
  try {
    const response = await axios().post("/notificar_acta", dataSend);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    toast.success("Se notifico el acta exitosamente", toastOptions);
    handlerModal({ modal: false, modalName: "notificar" });
    handlerModal({ modal: false, modalName: "notificar_seleccionadas" });
    handlerModal({ modal: false, modalName: "modal_notificar" });
    // console.log(data)
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_notificar" });
  }
};

//TODO Peticion para traer todo los motivos
export const getMotivos = async (dataSend) => {
  handlerLoading({ loading: true, loadName: "load_motivos" });
  try {
    const response = await axios().get("/get_motivos_notificador", dataSend);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_motivos" });
  }
};

//TODO Peticion para traer todo los motivos
export const getNotificarMismoTitular = async (dataSend) => {
  handlerLoading({ loading: true, loadName: "actas_mismo_titular" });
  try {
    const response = await axios().post("notificar_actas_mismo_titular", dataSend);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "actas_mismo_titular" });
  }
};

//TODO Peticion para traer todo los motivos
export const getActasRelacionadas = async (dataSend) => {
  handlerLoading({ loading: true, loadName: "actas_relacionadas" });
  try {
    const response = await axios().post("notificador_actas_relacionadas", dataSend);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "actas_relacionadas" });
  }
};

//TODO Peticion para el reporte de un notificador
export const reporteNotificadores = async (dataSend) => {
  handlerLoading({ loading: true, loadName: "reporte_notificadores" });
  try {
    const response = await axios().post("reportes_notificadores", dataSend);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "reporte_notificadores" });
  }
};
